module.exports = __webpack_public_path__ + "static/media/cloud-sync.c4cfe7a0.svg";